/* Movatic WMS — Frontend | CesarFilho 932048016 */
import CrudList from '@/components/CrudList'

export default function Carriers() {
  return (
    <CrudList
      title="Transportadoras"
      endpoint="/api/partners/carriers/"
      writable
      canDelete={false}
      columns={[
        { key: 'code', header: 'Código' },
        { key: 'name', header: 'Nome' },
        { key: 'is_active', header: 'Ativo' },
      ]}
    />
  )
}
